import { $window } from '../common/globals';
import {
  isUndefined,
  getCookieDomainUrl,
  nativeToast,
  isApp,
  checkMobileOperatingSystem,
} from '../common/utils';
import store from '@/common/store';
import * as common from '@common/store/modules/common/types';

export function getRedirectUri(uri) {
  try {
    return !isUndefined(uri)
      ? `${$window.location.origin}${uri}`
      : $window.location.origin;
  } catch (e) {
    /* empty */
  }

  return uri || null;
}

// 아이피 체크
export function checkIp() {
  const clientIP = sessionStorage.getItem('ip');
  /**
   * 퍼스 IP (스파크플러스 315호)
   * 1.214.195.226
   */
  const allowIP = ['118.33.55.126'];
  // const allowIP = ['1.214.195.227', '106.111.222']; // test용 ip
  let ipCh = false;
  for (let i in allowIP) {
    if (allowIP[i] === clientIP) {
      // console.log('allowed ip :: {}', clientIP);
      ipCh = true;
      break;
    } else {
      // console.log('block ip :: {}', clientIP);
    }
  }

  if (ipCh) {
    return true;
  } else {
    return false;
  }
}

// 시스템 점검 페이지 (사용자, 사장님)
export function systemMaintenance() {
  if (process.env.VUE_APP_APP_NAME !== 'admin') {
    const router =
      process.env.VUE_APP_APP_NAME === 'customer'
        ? require('@customer/router')
        : require('@owner/router');
    const now = Date.now();
    const start = Date.parse('2025-03-17 22:00:00');
    const end = Date.parse('2025-03-17 22:00:59');
    if (now >= start && now <= end) {
      router.default.replace({ path: '/maintenance' }).catch(() => {});
      return;
    }
  }
}

/**
 * Default configuration
 */
export default {
  baseUrl: null,
  loginUrl: '/auth/login',
  registerUrl: '/auth/register',
  logoutUrl: null,
  refreshUrl: '/auth/refresh',
  userInfoUrl: '/auth/user',
  mobileAuthUrl: '/auth/mobile', //모바일 인증 후 회원가입시
  tokenPath: 'access_token',
  tokenName: 'token',
  tokenPrefix: 'vueauth',
  tokenHeader: 'Authorization',
  tokenType: 'Bearer',
  refreshTokenPath: 'refresh_token',
  refreshTokenName: 'refresh_token',
  refreshTokenPrefix: 'vueauth',
  refreshTokenHeader: 'Refresh-Authorization',
  refreshTokenType: 'Bearer',
  storageType: 'localStorage',
  storageNamespace: 'vue-authenticate',
  cookieStorage: {
    domain: getCookieDomainUrl(),
    path: '/',
    secure: false,
  },
  requestDataKey: 'data',
  responseDataKey: 'data', //data, headers

  /**
   * Default request interceptor for Axios library
   * @context {VueAuthenticate}
   */
  bindRequestInterceptor: function($auth) {
    const tokenHeader = $auth.options.tokenHeader;

    $auth.$http.interceptors.request.use(async config => {
      // 접속된 아이피 확인
      const isAllow = checkIp();

      if (!isAllow) {
        systemMaintenance();
      }

      if (config.isLoading !== false)
        store.dispatch(common.ROOT_SHOW_LOADING, null, {
          root: true,
        });

      //console.log('interceptors request call');
      const isAuthenticated = await $auth.isAuthenticated(true);
      if (isAuthenticated) {
        config.headers[tokenHeader] = [
          $auth.options.tokenType,
          $auth.getToken(),
        ]
          .join(' ')
          .trim();
      } else {
        delete config.headers[tokenHeader];
      }

      return config;
    });
  },

  bindResponseInterceptor: function($auth) {
    $auth.$http.interceptors.response.use(
      //성공인경우
      function(response) {
        if (response.config.isLoading !== false)
          store.dispatch(common.ROOT_HIDE_LOADING, null, {
            root: true,
          });
        return response;
      },
      //에러인경우
      async function(err) {
        return new Promise(async function(resolve, reject) {
          let isExpirationToken = false;
          const errorAPI = err.config;
          console.log(
            'axios error',
            err,
            err.config,
            err.config.retry,
            err.response,
          );
          // 서버 에러 코드가 'EXPIRATION_TOKEN'이면(만료된 토큰) isExpirationToken = true;
          if (err.response && err.response.data) {
            const { code, message, fields, errors } = err.response.data;
            if (code === 'EXPIRATION_TOKEN') isExpirationToken = true;
          }
          if (
            err.response &&
            err.response.status === 401 &&
            isExpirationToken &&
            err.config &&
            !err.config.retry &&
            errorAPI.url !== $auth.getRefreshUrl()
          ) {
            // if you ever get an unauthorized, logout the user
            //this.$store.dispatch(AUTH_LOGOUT);
            //this.$store.dispatch('auth/LOGOUT'); // TODO:: FIX!
            // you can also redirect to /login if needed !
            errorAPI.retry = true;
            //console.log('interceptors response error call');
            await $auth.refresh();
            //console.log('refresh completed');
            const d = await $auth.$http(errorAPI);
            return resolve(d);
          }
          //토큰갱신요청url인데 401 이면 로그아웃처리.
          if (errorAPI.url === $auth.getRefreshUrl()) {
            $auth.logout({ purge: true });
            const router =
              process.env.VUE_APP_APP_NAME === 'admin'
                ? require('@admin/router')
                : process.env.VUE_APP_APP_NAME === 'customer'
                ? require('@customer/router')
                : require('@owner/router');
            router.default.push({ name: 'Auth.Login', query: { isRoot: 1 } });
            //location.href = process.env.BASE_URL;
            return reject(err);
          }
          if (
            err.response &&
            err.response.data &&
            err.response.status === 401
          ) {
            const { code, message, fields, errors } = err.response.data;
            if (code === 'NOT_FOUND_ACCOUNT' || code === 'NEED_TO_LOGIN') {
              $auth.logout({ purge: true });
              const router =
                process.env.VUE_APP_APP_NAME === 'admin'
                  ? require('@admin/router')
                  : process.env.VUE_APP_APP_NAME === 'customer'
                  ? require('@customer/router')
                  : require('@owner/router');
              router.default.push({ name: 'Auth.Login', query: { isRoot: 1 } });
              location.replace('/Auth/Login?isRoot=1');
              return reject(err);
            }
          }
          let fieldMessage = '';
          store.dispatch(common.ROOT_HIDE_LOADING, null, {
            root: true,
          });
          if (err.response && err.response.data) {
            const { code, message, fields, errors } = err.response.data;
            if (fields) {
              for (const key in fields) {
                fieldMessage +=
                  fieldMessage.length > 0 ? '\n' : '' + fields[key];
              }
            }
            if (errors) {
              errors.forEach(v => {
                fieldMessage +=
                  fieldMessage.length > 0
                    ? '\n'
                    : '' + `${v.field} : ${v.defaultMessage}`;
              });
            }
            fieldMessage = fieldMessage || message;
          } else {
            fieldMessage = '네트워크가 원활하지 않습니다.';
          }
          if (fieldMessage) {
            if (errorAPI.isErrMsg !== false) {
              const appName = process.env.VUE_APP_APP_NAME;
              if (appName === 'customer' || appName === 'owner') {
                if (
                  errorAPI.isErrToast &&
                  isApp() &&
                  checkMobileOperatingSystem() === 'Android'
                ) {
                  nativeToast(fieldMessage);
                } else {
                  if (store.state.common.appLoaded)
                    store.dispatch(
                      common.ROOT_SET_DIALOG,
                      {
                        type: 'normal',
                        icon: 'warning',
                        //title: this.$t('common.confirm'),
                        message: fieldMessage,
                      },
                      {
                        root: true,
                      },
                    );
                  else alert(fieldMessage);
                }
              } else {
                if (store.state.common.appLoaded)
                  store.dispatch(
                    common.ROOT_SET_SNACKBAR,
                    {
                      color: false,
                      message: fieldMessage,
                    },
                    {
                      root: true,
                    },
                  );
                else alert(fieldMessage);
              }
            }
          }
          //throw err;
          //console.log('hre');
          //console.log(fieldMessage);
          return reject(fieldMessage);
        });
      },
    );
  },
  introViewCheck: function() {
    // 사용자 인트로 화면
    const appName = process.env.VUE_APP_APP_NAME;

    if (appName == 'customer') {
      const introView = localStorage.getItem('customer_intro_view');

      // console.log('introViewintroViewintroView');
      // console.log(introView);

      if (introView) {
        return true;
        // console.log(123);
      } else {
        // let router = require('@customer/router');
        // // console.log(router);
        // router.default.replace({ path: '/Intro' }).catch(e => {
        //   // console.log(e);
        //   router.default.replace({ path: '/Intro' });
        // });
        return false;
      }
    }
    return true;
  },
  providers: {
    facebook: {
      name: 'facebook',
      url: '/auth/facebook',
      authorizationEndpoint: 'https://www.facebook.com/v5.0/dialog/oauth',
      redirectUri: getRedirectUri('/'),
      requiredUrlParams: ['display', 'scope'],
      scope: ['email'],
      scopeDelimiter: ',',
      display: 'popup',
      oauthType: '2.0',
      popupOptions: {
        width: 580,
        height: 400,
      },
    },

    google: {
      name: 'google',
      url: '/auth/google',
      authorizationEndpoint: 'https://accounts.google.com/o/oauth2/auth',
      redirectUri: getRedirectUri(),
      requiredUrlParams: ['scope'],
      optionalUrlParams: ['display'],
      scope: ['profile', 'email'],
      scopePrefix: 'openid',
      scopeDelimiter: ' ',
      display: 'popup',
      oauthType: '2.0',
      popupOptions: {
        width: 452,
        height: 633,
      },
    },

    github: {
      name: 'github',
      url: '/auth/github',
      authorizationEndpoint: 'https://github.com/login/oauth/authorize',
      redirectUri: getRedirectUri(),
      optionalUrlParams: ['scope'],
      scope: ['user:email'],
      scopeDelimiter: ' ',
      oauthType: '2.0',
      popupOptions: {
        width: 1020,
        height: 618,
      },
    },

    instagram: {
      name: 'instagram',
      url: '/auth/instagram',
      authorizationEndpoint: 'https://api.instagram.com/oauth/authorize',
      redirectUri: getRedirectUri(),
      requiredUrlParams: ['scope'],
      scope: ['basic'],
      scopeDelimiter: '+',
      oauthType: '2.0',
      popupOptions: {
        width: null,
        height: null,
      },
    },

    twitter: {
      name: 'twitter',
      url: '/auth/twitter',
      authorizationEndpoint: 'https://api.twitter.com/oauth/authenticate',
      redirectUri: getRedirectUri(),
      oauthType: '1.0',
      popupOptions: {
        width: 495,
        height: 645,
      },
    },

    bitbucket: {
      name: 'bitbucket',
      url: '/auth/bitbucket',
      authorizationEndpoint: 'https://bitbucket.org/site/oauth2/authorize',
      redirectUri: getRedirectUri('/'),
      optionalUrlParams: ['scope'],
      scope: ['email'],
      scopeDelimiter: ' ',
      oauthType: '2.0',
      popupOptions: {
        width: 1020,
        height: 618,
      },
    },

    linkedin: {
      name: 'linkedin',
      url: '/auth/linkedin',
      authorizationEndpoint: 'https://www.linkedin.com/oauth/v2/authorization',
      redirectUri: getRedirectUri(),
      requiredUrlParams: ['state'],
      scope: ['r_emailaddress'],
      scopeDelimiter: ' ',
      state: 'STATE',
      oauthType: '2.0',
      popupOptions: {
        width: 527,
        height: 582,
      },
    },

    live: {
      name: 'live',
      url: '/auth/live',
      authorizationEndpoint: 'https://login.live.com/oauth20_authorize.srf',
      redirectUri: getRedirectUri(),
      requiredUrlParams: ['display', 'scope'],
      scope: ['wl.emails'],
      scopeDelimiter: ' ',
      display: 'popup',
      oauthType: '2.0',
      popupOptions: {
        width: 500,
        height: 560,
      },
    },

    //https://medium.com/techulus/how-to-setup-sign-in-with-apple-9e142ce498d4
    apple: {
      name: 'apple',
      url: '/auth/apple',
      authorizationEndpoint: 'https://appleid.apple.com/auth/authorize',
      //redirectUri: encodeURIComponent(getRedirectUri()),
      redirectUri: encodeURIComponent('http://techulus.com:4000/callback'),
      requiredUrlParams: ['scope', 'response_mode', 'frame_id', 'm', 'v'],
      scope: ['name', 'email'],
      scopeDelimiter: ' ',
      responseType: 'code id_token',
      responseMode: 'form_post',
      m: '11',
      v: '1.4.1',
      oauthType: '2.0',
      popupOptions: {
        width: 500,
        height: 560,
      },
    },

    kakao: {
      name: 'kakao',
      url: '/auth/kakao',
      authorizationEndpoint: 'https://kauth.kakao.com/oauth/authorize',
      redirectUri: getRedirectUri(),
      display: 'popup',
      oauthType: '2.0',
      popupOptions: {
        width: 580,
        height: 400,
      },
    },

    oauth1: {
      name: null,
      url: '/auth/oauth1',
      authorizationEndpoint: null,
      redirectUri: getRedirectUri(),
      oauthType: '1.0',
      popupOptions: null,
    },

    oauth2: {
      name: null,
      url: '/auth/oauth2',
      clientId: null,
      redirectUri: getRedirectUri(),
      authorizationEndpoint: null,
      defaultUrlParams: ['response_type', 'client_id', 'redirect_uri'],
      requiredUrlParams: null,
      optionalUrlParams: null,
      scope: null,
      scopePrefix: null,
      scopeDelimiter: null,
      state: null,
      oauthType: '2.0',
      popupOptions: null,
      responseType: 'code',
      responseParams: {
        code: 'code',
        clientId: 'clientId',
        redirectUri: 'redirectUri',
      },
    },
  },
};
